export default __webpack_public_path__ + "e7a60d558500cf9b2d18a364c823d88b.svg";